import request from '../request'
/**
 *  获取所有的权限
 * @method getAllPermission
 * @return {[type]}         [description]
 */

//查询已发布的banner列表
export function sysBannerList(form) {
    return request({
        url: `web/sysBanner/front`,
        method: 'get',
        params: form,
    })
}

//查询已发布的首页图片列表
export function sysBannerindexImg(form) {
    return request({
        url: `web/sysBanner/front/indexImg`,
        method: 'get',
        params: form,
    })
}
